// eslint-disable-next-line import/prefer-default-export
export async function documentImagesHaveRendered(): Promise<void[]> {
  return Promise.all(
    Array.from(document.images).map(
      img =>
        new Promise<void>(resolve => {
          if (img.complete) resolve();
          else {
            img.addEventListener('load', () => resolve(), { once: true });
            img.addEventListener('error', () => resolve(), { once: true });
          }
        })
    )
  );
}
